module.exports = __webpack_public_path__ + "assets/imgs/qqzy.ce762985.png";